import React from 'react';

const StoreTable = (props) => {
  return (
    <div className='gridbgWhite'>
      <div style={{ margin: '10px' }}>
        <table
          className='table table-bordered table-striped mainGrid'
          style={{ borderCollapse: 'separate' }}
        >
          <thead style={{ background: '#3c8dbc', color: '#fff' }}>
            <tr>
              <th>
                <th>
                  <span>{'Store Names'}</span>
                </th>
              </th>
            </tr>
          </thead>
          <tbody>
            {props.storeData.stores ? (
              props.storeData.stores.map((index) => (
                <tr>
                  <td className='text-left' key={index.storeID}>
                    {index.storeName}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td>No Store Data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StoreTable;
